import * as COMPONENT from '@Components';
import { useLocation } from 'react-router-dom';
import clsx from 'classnames';
import '@Styles/profile.css';

export default function Page() {
  const { search } = useLocation();

  return (
    <div className="container profile">
      <div className="row align-items-start justify-content-center m-0 mt-4">
        <div className="col-md-4 col-xl-3 p-0 pe-md-5">
          <div
            className="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <button
              className={clsx("nav-link fw-medium", {
                "active": search === "?main" || search === ""
              })}
              id="profile-tab"
              data-bs-toggle="pill"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Profile
            </button>
            <button
              className={clsx("nav-link fw-medium mt-4", {
                "active": search === "?cart"
              })}
              id="cart-tab"
              data-bs-toggle="pill"
              data-bs-target="#cart"
              type="button"
              role="tab"
              aria-controls="cart"
              aria-selected="true"
            >
              Cart
            </button>
            <button
              className="nav-link fw-medium mt-4 disabled"
              id="settings-tab"
              data-bs-toggle="pill"
              data-bs-target="#settings"
              type="button"
              role="tab"
              aria-controls="settings"
              aria-selected="false"
              disabled
            >
              Settings
            </button>
          </div>
        </div>
        <div className="col-md-8 col-xl-9 p-0 mt-5 mt-md-0">
          <div className="tab-content" id="v-pills-tabContent">
            <COMPONENT.ProfileContent id="profile" active={(search === "?main" || search === "") && true}>
              <COMPONENT.ProfileMain />
            </COMPONENT.ProfileContent>
            <COMPONENT.ProfileContent id="cart" active={search === "?cart" && true}>
              <COMPONENT.ProfileCart />
            </COMPONENT.ProfileContent>
          </div>
        </div>
      </div>
    </div>
  );
}